import type { IAppConfig } from '@/typescript/interfaces/IAppConfig';

export function mockConfig(): IAppConfig {
    return {
        lang: 'fr_Fr',
        is_mobile: false,
        // is_mobile: !!import.meta.env.VITE_IS_MOBILE,
        token: import.meta.env.VITE_API_TOKEN,
        product_type: 'cup_33',
    };
}
